export default __webpack_public_path__ + "static/media/dcube.5125ff1e.png";